<template>
    <div class="page home-page px-md-8">
        <v-container class="py-3 py-lg-8 px-0">
            <transition name="fade-transition">
                <div v-if="settingsData">
                    <v-card flat class="bordered">
                        
                        <v-card-title class="mb-1 medium-title">
                            <v-icon color="primary" size="24" class="me-1">mdi-cog-outline</v-icon>
                            <span>إعدادات المتجر اﻷساسية</span>
                        </v-card-title>
                        <v-card-subtitle class="details-text px-5">تعديل اﻹعدادات الأساسية للمتجر الإلكتروني الخاص بك</v-card-subtitle>
                        <v-divider class="mx-5 my-1"></v-divider>

                        <v-card-text class="pb-6">
                            <!-- {{storeData.storename}} -->
                            <div class="my-3 d-flex flex-column align-center justify-center">
                                
                                <v-img v-if="storeData && storeData.logo" max-width="150" max-height="65" :src="storeData.logo" class="bordered"></v-img>
                                <v-img v-else width="150" height="50" class="surface2" style="border-radius: 15px"></v-img>

                                <div class="mt-3">
                                    <v-btn color="primary" outlined small @click="openLogoUpload">
                                        <v-icon left size="18" class="me-1">mdi-image</v-icon>
                                        <span>تغيير الشعار</span>
                                    </v-btn>
                                </div>
                                
                                <input ref="logoInput" type="file" @change="handleLogoUpload" accept="image/*" hidden multiple />
                            </div>

                            <v-list class="pa-0 transparent ma-0" max-width="700">
                                <settings-item flat :data="storeData" vuex-action="updateStore" name="name" icon="mdi-store" color="primary" title="اسم المتجر" subtitle="" @sync="sync"/>
                                <settings-item flat select :select-items="storeTypesItems" :data="storeData" vuex-action="updateStore" name="store_type_id" icon="mdi-store-cog" color="primary" title="نوع المتجر" subtitle="" @sync="sync"/>
                                <settings-item flat :data="storeData" vuex-action="updateStore" name="storename" icon="mdi-web" color="strong-text" title="معرّف المتجر (الرابط)" subtitle="يجب أن يحتوي على اﻷحرف الإنجليزية واﻷرقام والنقطة فقط" @sync="sync"/>
                                <settings-item v-if="subscription !== 'free'" flat :data="storeData" vuex-action="updateStore" nullable max-width name="domain" icon="mdi-web" color="strong-text" title="دومين خاص بالمتجر" subtitle="يجب أن يكون اسم دومين صحيح، مثلاً: e-khanh.com" @sync="sync">
                                    <template slot="body-top">
                                        <div class="text-center" style="line-height: 1.75">
                                            قم بتسجيل الدخول إلى لوحة إدارة النطاق أو الدومين الخاص بك
                                            من اعدادات الدي إن اس إضغط على تعديل اسماء الخوادم المخصصة Change to custom name servers
                                            أضف  أو استبدل اسماء الخوادم التالية:
                                            <br>
                                            <b class="strong-text--text">corey.ns.cloudflare.com</b>
                                            <br>
                                            <b class="strong-text--text">eva.ns.cloudflare.com</b>
                                            <br>
                                            <br>
                                            اذا لم يكن لديك رابط (دومين) خاص بمتجرك تواصل معنا:
                                            
                                            <div class="mt-2 mb-5">
                                                <v-btn as="a" target="_blank" dark color="green darken-1" depressed rounded href="https://wa.me/message/SB33RJKDEYR3A1">
                                                    <v-icon left>mdi-whatsapp</v-icon>
                                                    009647850387747
                                                </v-btn>
                                            </div>
                                        </div>
                                    </template>
                                </settings-item>

                                <v-list-item v-ripple="{class: 'ripple--color'}" @click="openIconUpload">
                                    <v-list-item-icon class="me-4 me-lg-6">
                                        <v-img width="24" height="24" :src="storeData && storeData.icon"></v-img>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>أيقونة المتجر</v-list-item-title>
                                        <v-list-item-subtitle>اضغط لتغيير اﻷيقونة</v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-icon color="muted">mdi-attachment</v-icon>

                                    <input ref="iconInput" type="file" @change="handleIconUpload" accept="image/*" hidden multiple />
                                </v-list-item>

                                <settings-item flat is-switch :data="settingsData" name="locked" icon="mdi-shield-lock-outline" :color="settingsData.locked ? 'error' : 'strong-text'" title="إغلاق المتجر مؤقتاً" subtitle="سيتوقف المتجر عن العمل وستظهر رسالة تفيد بالتوقف المؤقت" @sync="sync"/>
                                <!-- <settings-item flat :data="settingsData" vuex-action="updateStore" name="storename" icon="mdi-web" color="strong-text" title="رابط المتجر" subtitle="يجب أن يحتوي على اﻷحرف الإنجليزية واﻷرقام والنقطة فقط" @sync="sync"/> -->

                            </v-list>
                        </v-card-text>
                    </v-card>
                </div>
            </transition>
      </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import SettingsItem from '@/components/default/settings-item'


export default {
    name: "MainSettings",
    components: {
        SettingsItem,
    },
    data(){
        return {
            loading: false,
            updatingLogo: false,
            updatingIcon: false,
        }
    },
    computed: {
        ...GlobalComputed,
        settingsData(){
            return this.$store.state.storeModule.settings;
        },
        storeTypesItems(){
            return this.appData.store_types ? this.appData.store_types.map(type=>{
                return {text: type.name, value: type.id};
            }) : [];
        },
    },
    methods: {
        ...GlobalMethods,
        openIconUpload(){
            this.$refs.iconInput.click();
        },
        handleIconUpload(event){
            let files = event.target.files;
            if (files && files.length){
                this.changeIcon(files[0]);
            }
        },
        changeIcon(file){
            let formData = new FormData();
            formData.append('icon', file);

            if (!this.updatingIcon){
                this.updatingIcon = true;
                this.$store.dispatch('uploadIconImage', {data: formData, headers: {'Content-Type': 'multipart/form-data'}}).then(response=>{
                    this.updatingIcon = false;
                    this.showMsg('تمت رفع اﻷيقونة بنجاح', 'success');
                }).catch((e)=>{
                    this.updatingIcon = false;
                    this.showMsg('حدثت مشكلة أثناء الرفع', 'error');
                });
            }
        },

        openLogoUpload(){
            this.$refs.logoInput.click();
        },
        handleLogoUpload(event){
            let files = event.target.files;
            if (files && files.length){
                this.changeLogo(files[0]);
            }
        },
        changeLogo(file){
            let formData = new FormData();
            formData.append('logo', file);

            if (!this.updatingLogo){
                this.updatingLogo = true;
                this.$store.dispatch('uploadLogoImage', {data: formData, headers: {'Content-Type': 'multipart/form-data'}}).then(response=>{
                    this.updatingLogo = false;
                    this.showMsg('تمت رفع صورة الشعار بنجاح', 'success');
                }).catch((e)=>{
                    this.updatingLogo = false;
                    this.showMsg('حدثت مشكلة أثناء الرفع', 'error');
                });
            }
        },

        loadData(){
            if (!this.loading){
                this.loading = true;
                this.$store.dispatch('getStoreSettings').then(response=>{
                    this.loading = false;
                }).catch(e=>{
                    this.loading = false;
                    this.showMsg('حدثت مشكلة أثناء تحميل البيانات', 'error');
                })
            }
        },
        sync(data){
            this.$store.commit('UPDATE_STORE_SETTINGS', data);
        },
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        updatingLogo(loading){
            this.setLinearLoading(loading);
        }
    },
    mounted(){
        this.loadData();
    }
};
</script>
